import { Observable } from 'rxjs';
import { ProjectGraphsResponse } from '../models/graphs.types';

import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfigService } from '../../../core/services/api-config.service';
import { Period } from '../../../core/constants/periods';

export abstract class GraphsDataSource {
  abstract getGraphs(projectId: string, period: Period): Observable<ProjectGraphsResponse>;
}

export class ApiGraphsDataSource implements GraphsDataSource {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfigService);

  getGraphs(projectId: string, period: Period): Observable<ProjectGraphsResponse> {
    return this.http.get<ProjectGraphsResponse>(this.apiConfig.endpoint(`project/${projectId}/graphs`), {
      params: { period: period },
    });
  }
}
